import type { SanctumPlugin } from './types';

export type { SanctumPlugin, SanctumDocumentToolbarExtrasProps } from './types';

export const sanctumPlugin: SanctumPlugin = {};
